import { AfterViewInit, Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';

import { AuthService } from 'src/app/services/auth.service';
import { CriptoService } from 'src/app/services/cripto.service';
import { ProyectoService } from 'src/app/services/proyecto.service';
import { FormCotizacionesComponent } from '../form-cotizaciones/form-cotizaciones.component';

import Swal from 'sweetalert2';
import { TipoDeEstatus } from 'src/app/models/tipo-de-estatus.model';
import { DatePipe } from '@angular/common';


@Component({
  selector: 'app-historial-cotizaciones',
  templateUrl: './historial-cotizaciones.component.html',
  styleUrls: ['./historial-cotizaciones.component.scss'],
  providers: [DatePipe],
})
export class HistorialCotizacionesComponent implements OnInit, OnChanges, AfterViewInit {
  @Input() reload: number; // Variable que recibe desde el Parent Component
  @ViewChild(MatPaginator) paginator: MatPaginator;

  public idSocioDesencriptado: string;

  // Propiedades para la tabla de Angular Material
  public historialCotizaciones: any[] = [];
  public loading: boolean = false;
  displayedColumns: string[] = [
    'obra',
    'ubicacion',
    'propietario',
    'fechaCreacion',
    // 'fechaAprobacion',
    'estatus',
    'opciones',
  ];
  dataSource = new MatTableDataSource(this.historialCotizaciones);

  public estatus: TipoDeEstatus[] = [];
  public rows: TipoDeEstatus[];
  public tempFilterData: TipoDeEstatus[];
  public previousStatusFilter = '';
  private tempData: TipoDeEstatus[] = [];
  public selectedStatus: TipoDeEstatus;
  dataEstatus: MatTableDataSource<TipoDeEstatus>; 

  constructor(
    public dialog: MatDialog,
    private _proyectoService: ProyectoService,
    private datePipe: DatePipe,
    private _criptoService: CriptoService,
    private _router: Router,
    private _authService: AuthService,
  ) {
    this.idSocioDesencriptado = this._criptoService.decrypt(
      localStorage.getItem('idSocio')
    );
  }

  ngOnInit(): void {
    this.loading = true;
    //this.getHistorialCotizacionesSocio(); //this
    this.getEstatus();
    this.dataEstatus = new MatTableDataSource<TipoDeEstatus>(this.tempData);

  }

  ngOnChanges(): void {
    // Vuelve a llamar al api cada vez que se cambia a la pestaña 'Historial' para recargar la lista
    this.getHistorialCotizacionesSocio();
  }

  // Paginación para la tabla
  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
  }

  // Filtro de búsqueda para la tabla
  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  //Abre el modal de Angular Material
  openDialog(pIdCotizacion?) {
    const dialogRef = this.dialog.open(FormCotizacionesComponent, {
      height: 'auto',
      width: '800px',
      data: { idCotizacion: pIdCotizacion }, //Mandamos el idCotizacion al componente del Formulario para que pueda consultar a la API por el idCotizacion
    });

    // dialogRef.afterClosed().subscribe((result) => {
    //   //Recibe la propiedad 'statusResponse' cuando se cierra el modal de Angular Material
    //   //(Esto es para que haga el refresh de la tabla después de que se agregue, actualice o elimine un registro)
    //   if (result.statusResponse == true) {
    //     this.getProyectos();
    //   }
    // });
  }

  getEstatus(): void {
    this._proyectoService.getStatusCotizacion().subscribe(response => {
      this.estatus = response.data;
      console.log('this.estatus :>>', this.estatus);
  
      // Asigna los datos recuperados a tempData
      this.tempData = response.data;
  
      // Una vez que tengas los datos, puedes inicializar dataSource con ellos
      this.dataEstatus = new MatTableDataSource<TipoDeEstatus>(this.tempData);
    });
  }

  filterByStatus(event: number): void {
    console.log("oli", event);
    const filter = event || 0;
    
    if (typeof filter === 'number') {
      this.previousStatusFilter = filter.toString();
    } else {
      this.previousStatusFilter = '0';
    }
    
    this.tempFilterData = this.filterRows(filter);
    this.dataSource.data = this.tempFilterData;
  }
  
  private filterRows(statusFilter: number) {
    // Filtrar
    if (statusFilter === 0) {
      return this.tempData;
    } else {
      const filteredData = this.tempData.filter(row => row.idEstatus === statusFilter);
      console.log('Filtered Rows:', filteredData); 
      return filteredData;
    }
  }
  getHistorialCotizacionesSocio() {
    this._proyectoService
      .getHistorialCotizacionesSocio(this.idSocioDesencriptado)
      .subscribe(
        (response) => {
          console.log('getHistorialCotizaciones', response);
          this.dataSource.data = response.data;
          this.tempData = this.dataSource.data;
          this.tempFilterData = this.dataSource.data;

          // Labels pra la paginación de la tabla
          this.paginator._intl.itemsPerPageLabel = 'Registros por página';
          this.paginator._intl.previousPageLabel = 'Página anterior';
          this.paginator._intl.nextPageLabel = 'Siguiente página';
          this.paginator._intl.firstPageLabel = 'Primera página';
          this.paginator._intl.lastPageLabel = 'Última página';
          this.loading = false;
        },
        (error) => {
          console.log(error);
          this.loading = false;
          if (error.status === 401) {
            // logout
            this._authService.logout();
            this._router.navigate(['/login']);
          }
        }
      );
  }

  updateEstatus(idCotizacion: number) { //CONEJO
    console.log("Prueba de HOOOOY: ", idCotizacion);
    /**
     * idEstatus  Estatus
     *      1     Solicitado
     *      2     En Proceso
     *      3     Atendido
     *      4     Rechazado
     *      5     Cancelado
     */

    Swal.fire({
      title: '¿Desea generar la línea de pago para esta cotización?',
      text: 'Será redirigido a la página de pago en línea',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#2054A1',
      cancelButtonColor: '#78797A',
      confirmButtonText: 'Generar',
      cancelButtonText: 'Cancelar',
      html: `
      <div>
        <input type="radio" id="radio1" name="estatus" value="1">
        <label for="radio1">Pago en linea</label>
      </div>
      <div>
        <input type="radio" id="radio2" name="estatus" value="2">
        <label for="radio2">Monto original (+2.9%)</label>
      </div>
      <div>
        <input type="radio" id="radio3" name="estatus" value="3" checked>
        <label for="radio3">Pago por transferencia (Subir comprobante)</label>
      </div>
    `,
    }).then((result) => {
      if (result.value) {
        const selectedEstatus = (document.querySelector('input[name="estatus"]:checked') as HTMLInputElement).value;
        Swal.fire({
          allowOutsideClick: false,
          icon: 'info',
          title: 'Espere',
          text: 'Generando línea de pago',
        });

        Swal.showLoading();

        this._proyectoService.updateStatusCotizacion(idCotizacion, 3).subscribe(
          (response) => {
            console.log(response);
            // Swal.close();
            // this.getHistorialCotizacionesSocio();

            const idRuta = parseInt(selectedEstatus, 10);
            this.getCotizacion(idCotizacion, idRuta);
          },
          (error) => {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error al generar la línea de pago',
              text: 'Intente más tarde',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#2054A1',
            });
          }
        );
      }
    });
  }  

  getReview(idCotizacion: number) {
    console.log(idCotizacion);
  
    Swal.fire({
      title: '¿Está seguro de enviar a Revisión la Cotización?',
      text: '',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#2054A1',
      cancelButtonColor: '#78797A',
      confirmButtonText: 'Enviar a Revisión',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          allowOutsideClick: false,
          icon: 'info',
          title: 'Espere',
          text: 'Abriendo revisión de cotización...',
        });
  
        Swal.showLoading();
  
        this._proyectoService.updateStatusCotizacion(idCotizacion, 2).subscribe(
          (response) => {
            console.log(response);
            Swal.close();
  
            Swal.fire({
              icon: 'success',
              title: 'Revisión enviada correctamente',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#2054A1',
            });
  
            // Actualiza los datos de la tabla sin recargar la página
            this.updateTableData(idCotizacion, 2);
          },
          (error) => {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error al enviar la revisión',
              text: 'Intente más tarde',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#2054A1',
            });
          }
        );
      }
    });
  }
  
  // Nueva función para actualizar los datos de la tabla
  updateTableData(idCotizacion: number, newStatus: number) {
    // Encuentra la cotización en la lista y actualiza su estatus
    const cotizacion = this.dataSource.data.find(c => c.idCotizacion === idCotizacion);
    if (cotizacion) {
      cotizacion.idEstatus = newStatus;
      cotizacion.estatus = this.getStatusText(newStatus); // Asume que getStatusText es una función que convierte el idEstatus en texto
    }
  
    // Esto es para actualizar la tabla visualmente
    this.dataSource.data = [...this.dataSource.data];
  }
  
  // Función que convierte el idEstatus en texto
  getStatusText(statusId: number): string {
    const statusMap = {
      1: 'Creada',
      2: 'Revisar para pago',
      3: 'Aprovada para pago',
      4: 'Rechazado',
      5: 'Cancelado',
      6: 'Pagada y aprobada'
    };
    return statusMap[statusId] || 'Desconocido';
  }
  

  getTimelineReject(idCotizacion: number) {
    this._proyectoService.getAllIncidenciasCotizacion(idCotizacion).subscribe(
      (response) => {
        const mensajes = response.data.map((incidencia) => incidencia.incidencia);
        const fechas = response.data.map((incidencia) => this.datePipe.transform(incidencia.fecha, 'mediumDate'));
  
        let tablaHTML = `
          <style>
            .custom-table {
              width: 100%;
              border-collapse: collapse;
              font-family: Roboto, "Helvetica Neue", sans-serif;
            }
            .custom-table th, .custom-table td {
              padding: 8px;
              border-bottom: 1px solid #ddd;
              font-family: Roboto, "Helvetica Neue", sans-serif;
            }
            .custom-table th {
              background-color: #2054a1;
              color: white;
              font-weight: normal;
            }
            .custom-table td {
              font-size: 14px;
            }
            .fecha-col {
              width: 20%;
            }
            .comentario-col {
              width: 80%;
            }
          </style>
          <table class="custom-table">
            <tr>
              <th class="fecha-col">Fecha</th>
              <th class="comentario-col">Comentario</th>
            </tr>
        `;
        for (let i = 0; i < mensajes.length; i++) {
          tablaHTML += `
            <tr>
              <td class="fecha-col">${fechas[i]}</td>
              <td class="comentario-col">${mensajes[i]}</td>
            </tr>
          `;
        }
        tablaHTML += '</table>';
  
        Swal.fire({
          title: 'Historial de rechazos',
          html: tablaHTML,
          icon: 'info',
          showCancelButton: false,
          confirmButtonColor: '#2054A1',
          confirmButtonText: 'Cerrar',
        });
      },
      (error) => {
        console.error('Error al obtener los mensajes:', error);
        Swal.fire({
          title: 'Error',
          text: 'Error al obtener el historial de rechazos',
          icon: 'error',
          confirmButtonColor: '#2054A1',
          confirmButtonText: 'Aceptar',
        });
      }
    );
  }  
  
  getCotizacion(idCotizacion: number, idRuta: number) { //CONEJO
    this._proyectoService.getCotizacion(idCotizacion).subscribe(
      response => {
        //Redirige a la pantalla de 'Pago en Línea' con el idProducto como parámetro
        //Para que el nombre y precio aparezcan seleccionados por defecto

        let route = 'pago-online/';
        if (idRuta === 2 || idRuta === 3) {
          route = 'factura/';
          this._router.navigate([route, response.data.idProducto, idCotizacion]);
        }
        else 
          this._router.navigate([route, response.data.idProducto]);
        
        Swal.fire({
          icon: 'success',
          title: 'Línea de pago generada correctamente',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#2054A1',
        });
      },
      error => {
        console.log(error);
      }
    );
  }

  imprimirPDF(idCotizacion) {
    const url = 'https://reportserver.grupocase.com/ReportViewer?reportID=31192185-baa2-4dfd-a240-73dc3d707211&format=pdf&inline=true&getJSON=false&IdCot=';
    window.open(url + idCotizacion);
  }

  deleteCotizacion(idCotizacion: number) {
    Swal.fire({
      title: '¿Está seguro de eliminar este registro?',
      icon: 'info',
      showCancelButton: true,
      confirmButtonColor: '#2054A1',
      cancelButtonColor: '#78797A',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    }).then((result) => {
      if (result.value) {
        Swal.fire({
          allowOutsideClick: false,
          icon: 'info',
          title: 'Espere',
          text: 'Eliminando información',
        });

        Swal.showLoading();

        this._proyectoService.deleteCotizacion(idCotizacion).subscribe(
          response => {
            console.log(response);
            this.getHistorialCotizacionesSocio();
            Swal.fire({
              icon: 'success',
              title: 'Datos eliminados correctamente',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#2054A1',
            });
          },
          error => {
            console.log(error);
            Swal.fire({
              icon: 'error',
              title: 'Error al eliminar los datos',
              confirmButtonText: 'Aceptar',
              confirmButtonColor: '#2054A1',
            });
          }
        );
      }
    });
  }
}
